export default __webpack_public_path__ + "static/media/screentwo.52b8f62f.jpg";